import { ArrowUp, ArrowDown, Minus } from '@sweep-io/sweep-design/dist/icons';
import { colors, Typography } from '@sweep-io/sweep-design';
import { BestPracticeSeverity } from './types';
import { SEVERITY_LABELS } from './bestPracticesConsts';
import { Stack } from '@mui/material';

const SeverityIcon = ({ severity }: { severity: BestPracticeSeverity }) => {
  switch (severity) {
    case 'High':
      return <ArrowUp color={colors.blush[600]} size="small" />;
    case 'Medium':
      return <Minus color={colors.blue[500]} size="small" />;
    case 'Low':
      return <ArrowDown color={colors.grey[500]} size="small" />;
    default:
      return null;
  }
};

const Severity = ({
  severity,
  variant = 'default',
}: {
  severity: BestPracticeSeverity;
  variant?: 'strong' | 'default';
}) => {
  const isStrong = variant === 'strong';
  const severityLabel = SEVERITY_LABELS[severity] ?? severity;
  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      <Typography
        variant={isStrong ? 'caption' : 'caption-medium'}
        color={isStrong ? colors.grey[900] : colors.grey[500]}
      >
        {severityLabel}
      </Typography>
      <SeverityIcon severity={severity} />
    </Stack>
  );
};

export default Severity;
